"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4236],{

/***/ 14236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ThumbsType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84849);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33030);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function ThumbsType(props) {
    var dateLocale = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    var itemWrapperClassName = props.hasOwnProperty("itemWrapperClassName") && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.itemWrapperClassName) ? props.itemWrapperClassName : "d-flex col-12 col-sm-6 col-md-4 col-lg-3";
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var container_class = "container";
    var card_class = "card shadow-none ";
    if (props.type == "blog") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
            container_class = builder.builder_news_view_width;
        }
        card_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_radius") ? "border-radius-".concat(builder.builder_news_radius, " ") : "";
        card_class += !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjPositiveInteger */ .Z.isValidObjPositiveInteger(builder, "builder_news_border") ? "bg-transparent" : "border";
    } else if (props.type == "category") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
            container_class = content.category_view_width;
        }
        card_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(content, "tiles_radius") ? "border-radius-".concat(content.tiles_radius, " ") : "";
        card_class += !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].booleanState */ .Z.booleanState(content.view_type_with_border) ? "bg-transparent" : "border";
    }
    var skeletonArticles = [];
    for(var i = 0; i < 6; i++){
        skeletonArticles.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "d-flex col-12 col-sm-6 col-md-4 col-lg-3",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        height: 365,
                        className: "col-12"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        height: 18,
                        className: "col-12 col-sm-6 col-md-4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        height: 25,
                        className: "col-12 col-sm-8 col-md-6"
                    })
                ]
            })
        }, i.toString()));
    }
    var textColor = function() {
        if (props.textColor) {
            return "text-light-color";
        }
        return;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(container_class, " pb-5"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 m-0 d-flex justify-content-center",
            children: props.loadingArticles ? skeletonArticles : articles != undefined && articles.length > 0 && articles.map(function(article, index) {
                var created = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .formatMomentDate */ .XY)(dateLocale, new Date(article.created * 1000), "dddd Do MMMM");
                var title = props.articlesContentType == "blog" ? created : article.title;
                var subtitle = props.articlesContentType == "article" ? article.subtitle : props.articlesContentType == "blog" ? article.title : article.description;
                // card_class += article.has_description == '1' ? '\ cursor-pointer' : '';
                if (props.hasOwnProperty("articlesLimit") && (index < props.articlesLimit || props.articlesLimit === null) || !props.hasOwnProperty("articlesLimit")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        parentClassName: "col-12 col-sm-6 col-md-4 col-lg-3",
                        skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    height: 365,
                                    className: "col-12"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    height: 18,
                                    className: "col-12 col-sm-6 col-md-4"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    height: 25,
                                    className: "col-12 col-sm-8 col-md-6"
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: itemWrapperClassName,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                href: props.updateHref(article),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    onClick: function() {
                                        return props.clickHandler(article);
                                    },
                                    className: props.setClass(article, card_class) + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.itemClassName) ? props.itemClassName : ""),
                                    style: {
                                        cursor: article.has_description == "1" ? "pointer" : null,
                                        backgroundColor: props.backgroundColor != null ? props.backgroundColor : ""
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "bg-master-light",
                                            style: {
                                                height: 365
                                            },
                                            children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                layout: "fill",
                                                sizes: "75vw",
                                                quality: "75",
                                                src: article.image,
                                                alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : "Post Img",
                                                placeholder: "blur",
                                                blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "card-body",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-uppercase hint-text fw-bold small-text text-master text-design-color text-truncate",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: textColor() + " fw-bold text-black line-clamp-2",
                                                    children: subtitle
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }, article.id.toString());
                }
            })
        })
    });
}


/***/ })

}]);